import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = () => ({
    lineHeight: '1.875rem',
});

export const author: TRuleWithTheme = () => ({
    marginRight: '1.5rem',
});

export const categories: TRuleWithTheme = () => ({
    marginRight: '1.5rem',
});

export const date: TRuleWithTheme = ({ theme: { colors } }) => ({
    textTransform: 'uppercase',
    color: colors.lightGrey,
    fontWeight: '700',
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
});
